import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import axios from 'axios';
import {
  makeStyles,
  useTheme,
  Button,
  Typography,
  Grid,
  Box,
  AppBar,
  Tabs,
  Tab,
  Fab,
} from '@material-ui/core/';
import EditStornoTextModal from './Modals/EditStornoTextModal';
import EditInfoTextModal from './Modals/EditInfoTextModal';
import EditIcon from '@material-ui/icons/Edit';
import { defaultPriceInfoText, defaultStornoText } from '../defaultData';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }  

const useStyles = makeStyles(() => ({
    root: {
      maxWidth: 500,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      zIndex:2,
      textAlign: 'center',
      padding: '2% 0%',
    },
    marBot: {
      marginBottom: '14%',
    },
    gridItem: {
      width: '80%',
    },
    shadowless: {
        boxShadow: 'none !important',
    }
  }));

  function PriceInfo({ admin, API }) {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [editStornoTextModal, setEditStornoTextModal] = useState(false);
    const [editInfoTextModal, setEditInfoTextModal] = useState(false);
    const [stornoTextId, setStornoTextId] = useState('');
    const [infoTextId, setInfoTextId] = useState('');
    const [infoText, setInfoText] = useState(defaultPriceInfoText);
    const [stornoText, setStornoText] = useState(defaultStornoText)

    useEffect(() => {
      function fetchStornoText() {
        return new Promise( resolve => {
            axios.get(`${API}stornoText`)
              .then( res => {
                resolve(res.data);
              })
              .catch(err => console.log(err));
        })
      };

      function fetchInfoText() {
        return new Promise( resolve => {
            axios.get(`${API}infoText`)
              .then( res => {
                resolve(res.data);
              })
              .catch(err => console.log(err));
        })
      };
  
      async function loadStornoText() {
          const stornoText = await fetchStornoText();
          const infoText = await fetchInfoText();

          setStornoText({
            header: stornoText[0].header,
            lineOne: stornoText[0].lineOne,
            lineTwo: stornoText[0].lineTwo,
            lineThree: stornoText[0].lineThree,
            lineFour: stornoText[0].lineFour,
            lineFive: stornoText[0].lineFive,
            lineSix: stornoText[0].lineSix,
            lineSeven: stornoText[0].lineSeven,
          });
          setInfoText({
            lineOne: infoText[0].lineOne,
            lineTwo: infoText[0].lineTwo,
            lineThree: infoText[0].lineThree,
            lineFour: infoText[0].lineFour,
            lineFive: infoText[0].lineFive,
            strongLine: infoText[0].strongLine,
          });

          setStornoTextId(stornoText[0]._id);
          setInfoTextId(infoText[0]._id);
      };

      loadStornoText();
    }, [API]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleEditStornoTextModal = () => setEditStornoTextModal(!editStornoTextModal);
    const handleEditInfoTextModal = () => setEditInfoTextModal(!editInfoTextModal);

    const stornoProps = {
      stornoText,
      setStornoText,
      stornoTextId,
      onClose: handleEditStornoTextModal,
      API,
    }

    const infoProps = {
      infoText,
      setInfoText,
      infoTextId,
      onClose: handleEditInfoTextModal,
      API,
    }

    return(
        <Grid className={classes.root} direction='column'>
                <AppBar className={classes.shadowless} position="static" color="transparent">
                    <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs"
                    >
                    <Tab style={{fontSize: 'large'}} label="Informace" {...a11yProps(0)} />
                    <Tab style={{fontSize: 'large'}} label="Storno" {...a11yProps(1)} />
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                      {
                        (admin && admin.username) &&
                          <Grid container justify='flex-end'>
                            <Fab 
                              color="primary" 
                              size='small' 
                              aria-label="edit"
                              style={{ marginRight: '2vw' }}
                              onClick={() => handleEditInfoTextModal()}
                            >
                              <EditIcon />
                            </Fab>
                          </Grid>
                      }
                      {
                        editInfoTextModal ?
                          <EditInfoTextModal {...infoProps} />
                        :
                          <Typography className={classes.marBot} variant="body1" color='textPrimary' >
                              {infoText.lineOne}
                              <br />
                              {infoText.lineTwo}
                              <br />
                              {infoText.lineThree}
                              <br /><br />
                              {infoText.lineFour}
                              <br />
                              {infoText.lineFive}
                              <br /><br />
                              <strong>
                              {infoText.strongLine}
                              </strong>
                          </Typography>
                      }
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                      {
                        (admin && admin.username) &&
                          <Grid container justify='flex-end'>
                            <Fab 
                              color="primary" 
                              size='small' 
                              aria-label="edit"
                              style={{ marginRight: '2vw' }}
                              onClick={() => handleEditStornoTextModal()}
                            >
                              <EditIcon />
                            </Fab>
                          </Grid>
                      }
                      {
                        editStornoTextModal ?
                          <EditStornoTextModal {...stornoProps} />
                        :
                          <Typography align='left'>
                              {stornoText.header}
                              <br /><br />
                              {stornoText.lineOne}
                              <br /><br />
                              {stornoText.lineTwo}
                              <br /><br />
                              {stornoText.lineThree}
                              <br /><br />
                              {stornoText.lineFour}
                              <br /><br />
                              {stornoText.lineFive}
                              <br /><br />
                              {stornoText.lineSix}
                              <br /><br />
                              {stornoText.lineSeven}
                          </Typography>
                      }
                        
                    </TabPanel>
                </SwipeableViews>
                <Button href='contact' variant='outlined' color='primary'>
                    Pro více informací nás kontaktujte
                </Button>
        </Grid>
    )
  }

  export default PriceInfo;